import { render, staticRenderFns } from "./table-municipality.vue?vue&type=template&id=9806dc3c&scoped=true&"
import script from "./table-municipality.vue?vue&type=script&lang=js&"
export * from "./table-municipality.vue?vue&type=script&lang=js&"
import style0 from "./table-municipality.vue?vue&type=style&index=0&id=9806dc3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9806dc3c",
  null
  
)

export default component.exports